const prefix = 'auth/'

const type = {
    LOGIN: prefix + 'login',
    LOGOUT: prefix + 'logout',
    GET_USER_INFO: prefix + 'get_user_info',
    CHECK_SESSION: prefix + 'check_session',
    UPDATE_STATE: prefix + 'update_state',
    UPDATE_USERINFO: prefix + "update",
    CHANGE_PASSWORD: prefix + "changepass",

}

const action = {
    login: (username, password) => {
        return {
            type: type.LOGIN,
            payload: {
                username,
                password,
            },
        }
    },
    logout: () => {
        return {
            type: type.LOGOUT,
            payload: {},
        }
    },
    getUserInfo: () => {
        return {
            type: type.GET_USER_INFO,
            payload: {},
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    checkSession: () => {
        return {
            type: type.CHECK_SESSION,
            payload: {},
        }
    },
    updateUserInfo: (uid, body) => {
        return {
          type: type.UPDATE_USERINFO,
          payload: {
            uid, body
          }
        };
      },
    changePassword: (body) => {
        return {
          type: type.CHANGE_PASSWORD,
          payload: {
             body
          }
        };
    },
    
}

export default {
    type,
    action,
}
